import { css, Interpolation, Theme } from '@emotion/react'
import { buttonBaseClasses, outlinedInputClasses } from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const cell: Interpolation<Theme> = (theme: Theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`

export const value: Interpolation<Theme> = (theme: Theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  svg {
    height: 20px;
    width: 20px;
    min-width: 20px;
  }
`

export const input: Interpolation<Theme> = (theme: Theme) => css`
  width: 100%;

  .${outlinedInputClasses.root} {
    border: none;
    box-shadow: none;

    background-color: ${theme.colors.backgroundThree};
  }
`

export const iconButton: Interpolation<Theme> = css`
  &.${buttonBaseClasses.root} {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`

export const popperList: Interpolation<Theme> = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: 6px;

  padding: ${theme.spacing(1)};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 4)};

  list-style-type: none;

  background-color: ${theme.backgrounds.backgroundFour};
`

export const popperListButton: Interpolation<Theme> = (theme: Theme) => css`
  justify-content: flex-start;

  width: 100%;
  padding: ${theme.spacing(1.25)};
  border: none;
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};

  color: ${theme.colors.typographyTwo};
  font-weight: 500;

  :hover {
    border: none;

    background-color: ${theme.colors.grayHover};
  }
`
